import { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RemittanceIcon, InsuranceIcon, FinancingIcon } from "../lead-inventory/icons";

import RelatedTab from './RelatedTab';
import StatisticsTab from './StatisticsTab';
import ContactsTab from './ContactsTab';
import DocumentsTab from './DocumentsTab';
import { useAccDetDetails } from '../../api/account/useAccDetDetails';
import { useHunterFarmerList } from '../../api/auth/useHunterFarmerList';
import { apiRequest } from '../../network/apiClient';
import  {AccountDetailsSkeleton} from './skeleton/AccountDetailsSkeleton'
import { API_ENDPOINTS } from '../../api/apiEndpoints';


export default function AccountDetailsDetails({accountOwner, leadID}) {

    // Initialize API call
    
    const { leadJourneyAPI, accDetsAPI, associatedProdAPI, loading, refetch } = useAccDetDetails({leadID});
    const { hunterListAPI, farmerListAPI } = useHunterFarmerList();


    const [leadJourney, setLeadJourney] = useState(null);

    const [accDets, setAccDets] = useState(null);
    const [hunterList, setHunterList] = useState(null);
    const [farmerList, setFarmerList] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        race_of_pic_others: ''
    });
    const [showReassignModal, setShowReassignModal] = useState(false);
    const [showReassignConfirmationModal, setShowReassignConfirmationModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [selectedFarmer, setSelectedFarmer] = useState('');
    

    const [activeTab, setActiveTab] = useState(0);

    // Safe clipboard copy function
    const handleCopyToClipboard = (text) => {
        if (typeof window !== 'undefined' && navigator.clipboard) {
            navigator.clipboard.writeText(text || '');
            toast.success('Copied to clipboard!');
        }
    };

    const relationshipStrengthMap = {
        1: { label: "Cold", icon: <img src="/icons/cold.svg" className='size-8 -mt-1'/> }, // Cold
        2: { label: "Warm", icon: <img src="/icons/warm.svg" className='size-8 -mt-1'/>  }, // Warm
        3: { label: "Hot", icon: <img src="/icons/hot.svg" className='size-8 -mt-1'/>  },   // Hot
    };

    const relationshipStrengthSelectMap = {
        "Cold" : "Cold",
        "Warm" : "Warm",
        "Hot" : "Hot",
    };

    // Map between numeric API values and string dropdown values
    const relationshipStrengthNumericMap = {
        1: "Cold",
        2: "Warm",
        3: "Hot",
    };

    const relationshipStrengthStringToNumericMap = {
        "Cold": 1,
        "Warm": 2,
        "Hot": 3,
    };

    const industryMap = {
        "Agriculture": "Agriculture",
        "Art, Entertainment and Recreation": "Art, Entertainment and Recreation",
        "Automotives & Motorcycles": "Automotives & Motorcycles",
        "Beauty & Wellness": "Beauty & Wellness",
        "Building Cleaning, Pest Control & Gardening Services": "Building Cleaning, Pest Control & Gardening Services",
        "Charity & Voluntary work": "Charity & Voluntary work",
        "Computer Hardware / Software / Electronic Devices": "Computer Hardware / Software / Electronic Devices",
        "Construction": "Construction",
        "Customized Gifts / Souvenirs / Printing": "Customized Gifts / Souvenirs / Printing",
        "Employment Related": "Employment Related",
        "Event Management": "Event Management",
        "Fabric, Apparel & Accessories": "Fabric, Apparel & Accessories",
        "Family & Baby": "Family & Baby",
        "Finance / Investment / Wealth Management": "Finance / Investment / Wealth Management",
        "Food & Beverages - Product": "Food & Beverages - Product",
        "Food and Beverages - Service": "Food and Beverages - Service",
        "Healthcare": "Healthcare",
        "Home Furniture & Hardware Appliances": "Home Furniture & Hardware Appliances",
        "Hospitality / Travel": "Hospitality / Travel",
        "Industrial Goods": "Industrial Goods",
        "Information Technology": "Information Technology",
        "Logistics": "Logistics",
        "Machinery": "Machinery",
        "Management / Administrative": "Management / Administrative",
        "Media / Marketing": "Media / Marketing",
        "Medical & Pharmaceuticals": "Medical & Pharmaceuticals",
        "Oil & Gas": "Oil & Gas",
        "Pets Supplies": "Pets Supplies",
        "Real Estate": "Real Estate",
        "Regulatory (Legal / Accounting)": "Regulatory (Legal / Accounting)",
        "Research / Consultancy": "Research / Consultancy",
        "Religious Services": "Religious Services",
        "Sales": "Sales",
        "Science & Education": "Science & Education",
        "Security": "Security",
        "Sports, Hobbies & Recreation": "Sports, Hobbies & Recreation",
        "Telecommunications": "Telecommunications",
        "Transportation": "Transportation",
        "Weapons / Defence / Aerospace": "Weapons / Defence / Aerospace",
        "Others": "Others",
    };

    const natureOfBusinessMap = {
        "Agencies / Intermediaries / other services": "Agencies / Intermediaries / other services",
        "Distributor": "Distributor",
        "Manufacturing": "Manufacturing",
        "Non-Profit": "Non-Profit",
        "Professional Services": "Professional Services",
        "Retail": "Retail",
        "Trading": "Trading",
    };

    const handleRelationshipStrengthChange = (e) => {
        const stringValue = e.target.value; // Get string value from dropdown
        const numericValue = relationshipStrengthStringToNumericMap[stringValue]; // Convert to numeric for API
        setFormData(prevState => ({
            ...prevState,
            interest_level: numericValue
        }));
    };
    
    useEffect(() => {
        if (leadJourneyAPI) {
            setLeadJourney(leadJourneyAPI);
            setFormData(leadJourneyAPI);
        }
        if (accDetsAPI) {
            setAccDets(accDetsAPI);
        }
        
    }, [leadJourneyAPI, accDetsAPI]);

    
    // Initialize hunter & farmer listt
    useEffect(() => {
        // if (!lead_id) return;
        setHunterList(hunterListAPI);
        setFarmerList(farmerListAPI);
        
    }, [hunterListAPI, farmerListAPI]);
    
    
    // Initialize tabs
    let tabs = ["Details", "Related", "Statistics", "Documents", "Contacts"];
    
    if (!accountOwner) {
        tabs = ["Details", "Related", "Statistics", "Contacts"];
    }
    const handleEditClick = () => {
        setIsEditing(!isEditing);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        setAccDets(prev => ({
            ...prev,
            [name]: value
        }));
            
    };

    const handleSubmit = () => {
        setShowReassignConfirmationModal(true); 
    };

    // Update the latest data
    const handleReassignConfirmation = async (e) => {
        e.preventDefault();
        console.log("Form Data:", formData)
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_ACCOUNTS.DETAILS}?lead_id=${leadID}`, 'POST', formData);
            if (result) {
                setIsEditing(false);
                // Refetch the Latest data and reassign the data to display
                refetch();
                setLeadJourney(leadJourneyAPI);
                setFormData(leadJourneyAPI);
            }
        } catch (error) {
            console.error("Error updating account details:", error);
        }

        setShowReassignConfirmationModal(false);
    }

    const handleCancel = () => {
        setIsEditing(false); // Exit edit mode
        setFormData(leadJourney); // Revert form data back to the original leadJourney data
    };

    const handleReassignClick = () => {
        setShowReassignModal(true); // Show the reassign modal
    };

    const handleReassignSubmit = () => {
        // Find the selected hunter's details from hunterList
        const selectedFarmerDetails = farmerList.find(h => h.username === selectedFarmer);
        if (selectedFarmerDetails) {
            // Update formData with the selected hunter's id and username
            setFormData(prevState => ({
                ...prevState,
                farmer_id: selectedFarmerDetails.id,
                farmer_name: selectedFarmerDetails.username
            }));
        }
    
        setShowReassignModal(false); // Close the reassign modal
        setShowConfirmationModal(true); // Show the confirmation modal
    };

    const handleConfirmationSubmit = async (e) => {
        e.preventDefault();

        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_ACCOUNTS.DETAILS}?lead_id=${leadID}`, 'POST', formData);
            if (result){
                refetch();
                setLeadJourney(leadJourneyAPI);
                setFormData(leadJourneyAPI);
                setAccDets(accDetsAPI);
            }
        }catch(error){
            console.error("Error updating account details:", error);
        }finally{
            setShowConfirmationModal(false);
        }
    };

    const handleConfirmationCancel = () => {
        setShowConfirmationModal(false); // Close the confirmation modal
        setShowReassignConfirmationModal(false);
    };

    
    const racesList = ["Malay", "Chinese", "Indian", "Others"]; // Add more races as needed


    const racesOptions = racesList.map(race => ({
        value: race,
        label: race
    }));


    if (loading || !leadJourney || !accDets) {
        return <AccountDetailsSkeleton />
    }

    const relationshipStrength = leadJourney.interest_level; // Assuming this is the field in your data
    const { label, icon } = relationshipStrengthMap[relationshipStrength] || { label: "Unknown", icon: "❓" };

    const getOpportunityStatus = (status) => {
        const styles = {
            'Raw Lead': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Fresh Lead': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Profile Completed': "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
            'Activated': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Informaton Gathered': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Onboarded': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Collecting Documents': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Compliance Reviewing': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'KYC Approved': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'To Be Re-KYC': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'KYC Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Preparing Quotations': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Pending Selected': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Pending Payment': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Expired': "bg-[#EEEEEE] border-[#EEEEEE] text-[#94A3B8]"
        };
        return styles[status] || "bg-gray-100 text-gray-600";
    };

    return (
        <div className="w-full flex justify-between items-center ml-2">
            {/* Inner Grey Container */}
            <div className=" p-4 rounded-3xl w-full mr-2">
                {/* Tabs Container */}
                <div className="flex space-x-6 ml-3">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setActiveTab(index); // Set the active tab
                            }}
                            className={`relative text-md font-medium pb-1 transition-all mb-3 ${
                                activeTab === index ? "text-black border-b-4 pl-2 pr-2 border-yellow-300" : "text-gray-500"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                

                {/* Dynamic Content Based on Active Tab */}
                {activeTab === 0 && leadJourney && accDets && (
                    <div className='w-full bg-white p-7 rounded-3xl shadow-lg'>
                        {/* Lead Ownership Section */}
                        <div className="flex justify-between items-start">
                            <div className="flex items-center">
                                <p className="font-bold text-2xl">Account Ownership</p>
                            </div>
                            <div className="flex space-x-2">
                                {isEditing && (
                                    <button
                                        className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-gray-200 transition flex items-center justify-center w-12 h-12"
                                        onClick={handleCancel}
                                        aria-label="Cancel Editing"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="size-6"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M6 18 18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                    )}
                                {accountOwner && (
                                    <button
                                        className="group bg-white text-black p-3 rounded-full border-[1px] border-black hover:bg-yellow-300 transition flex items-center justify-center w-12 h-12"
                                        onClick={isEditing ? handleSubmit : handleEditClick}
                                        aria-label={isEditing ? 'Submit' : 'Edit Lead'}
                                        >
                                        {isEditing ? (
                                            <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="size-6"
                                            >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="m4.5 12.75 6 6 9-13.5"
                                            />
                                            </svg>
                                        ) : (
                                            <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="size-6"
                                            >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                                            />
                                            </svg>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Grid Container for All Rows */}
                        <div className="grid grid-cols-2 gap-x-5 ml-5 text-[#475569]">
                            {/* Product Ownership Section */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Name in MMT</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="company_name"
                                            value={formData.company_name || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left cursor-not-allowed"
                                            disabled
                                            readOnly
                                        />
                                        
                                    ) : (
                                        <div className="flex-1 flex items-center">
                                            <span>{leadJourney.company_name}</span>
                                        </div>
                                    )}
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(leadJourney.company_name);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                    
                                </div>
                            </div>
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Account Source</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="hunter_id"
                                            value={formData.lead_source || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left cursor-not-allowed mr-6"
                                            disabled // Disable the input field
                                            readOnly // Make it read-only
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.lead_source}</span>
                                    )}
                                    {/* <button
                                        onClick={handleReassignClick}
                                        className="text-black underline hover:text-blue-800 focus:outline-none mr-2 font-bold text-sm"
                                        >
                                        Reassign
                                    </button> */}
                                </div>
                                
                            </div>

                            {/* Contact Method and Lead Source */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Account Owner</b></span>
                                    <span className="flex-1">{accDets.farmer_name}</span>
                                    {accountOwner && (
                                        <button
                                        onClick={handleReassignClick}
                                        className="text-black underline hover:text-blue-800 focus:outline-none mr-2 font-bold text-sm"
                                        >
                                        Reassign
                                    </button> 
                                    )}
                                </div>
                            </div>
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Hunter</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="lead_source"
                                            value={formData.hunter_name || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left cursor-not-allowed"
                                            disabled
                                            readOnly
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.hunter_name}</span>
                                    )}
                                </div>
                            </div>

                            <div className="flex items-center mt-5 mb-2">
                                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Product Associated</p>
                            </div>
                            <br></br>
                            {/* Product Ownership Section - Display only Remittance Financing, Insurance, and Insurance Renewal */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3 gap-2 flex items-center">
                                    <img src={RemittanceIcon} alt="Remittance" className="w-6 h-6 inline-block gap-1" />
                                    <b>Remittance</b>
                                    </span>
                                    <div className="flex-1 flex items-center">
                                        {(() => {
                                            const remittanceProd = associatedProdAPI?.find(prod => prod.funnel === 'Remittance');
                                            if (remittanceProd) {
                                                return (
                                                    <span className={`w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold ${getOpportunityStatus(remittanceProd.status_name)} text-sm`}>
                                                        {remittanceProd.status_name}
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span className="w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold bg-[#FEE2E2] border-[#FEE2E2] text-[#8B0000] text-sm">
                                                        N/A
                                                    </span>
                                                );
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3 gap-2 flex items-center">
                                    <img src={FinancingIcon} alt="Financing" className="w-6 h-6 inline-block gap-1" />
                                    <b>Financing</b>
                                    </span>
                                    <div className="flex-1 flex items-center">
                                        {(() => {
                                            const financingProduct = associatedProdAPI?.find(prod => prod.funnel === 'Financing');
                                            if (financingProduct) {
                                                return (
                                                    <span className={`w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold ${getOpportunityStatus(financingProduct.status_name)} text-sm`}>
                                                        {financingProduct.status_name}
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span className="w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold bg-[#FEE2E2] border-[#FEE2E2] text-[#8B0000] text-sm">
                                                        N/A
                                                    </span>
                                                );
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3 gap-2 flex items-center">
                                    <img src={InsuranceIcon} alt="Insurance" className="w-6 h-6 inline-block gap-1" />
                                    <b>Insurance</b>
                                    </span>
                                    <div className="flex-1 flex items-center">
                                        {(() => {
                                            const insuranceProduct = associatedProdAPI?.find(prod => prod.funnel === 'Insurance');
                                            if (insuranceProduct) {
                                                return (
                                                    <span className={`w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold ${getOpportunityStatus(insuranceProduct.status_name)} text-sm`}>
                                                        {insuranceProduct.status_name}
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span className="w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold bg-[#FEE2E2] border-[#FEE2E2] text-[#8B0000] text-sm">
                                                        N/A
                                                    </span>
                                                );
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3 gap-2 flex items-center">
                                    <img src={InsuranceIcon} alt="Insurance" className="w-6 h-6 inline-block gap-1" />
                                    <b>Insurance Renewal</b>
                                    </span>
                                    <div className="flex-1 flex items-center">
                                        {(() => {
                                            const renewalProduct = associatedProdAPI?.find(prod => prod.funnel === 'InsuranceRenewal');
                                            if (renewalProduct) {
                                                return (
                                                    <span className={`w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold ${getOpportunityStatus(renewalProduct.status_name)} text-sm`}>
                                                        {renewalProduct.status_name}
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span className="w-auto h-auto py-2 px-5 gap-2 top-5 left-[22px] -ml-3 rounded-full border font-bold bg-[#FEE2E2] border-[#FEE2E2] text-[#8B0000] text-sm">
                                                        N/A
                                                    </span>
                                                );
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center mt-5 mb-2">
                                <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">General Information</p>
                            </div>
                            <br></br>
                            {/* MM Account ID */}
                            <div className="col-span-2 flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/6"><b>MM Account ID</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="name"
                                            value={leadJourney.mm_acc_id || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left cursor-not-allowed"
                                            disabled
                                            readOnly
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.mm_acc_id}</span>
                                    )}
                                    <button
                                        onClick={() => handleCopyToClipboard(leadJourney?.mm_acc_id)}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </div>
                            </div>
                            {/* Nature of Business and Industry */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Nature of Business</b></span>
                                    {isEditing ? (
                                        <select
                                            name="nature_of_business"
                                            value={formData.nature_of_business || ""}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        >
                                            <option value="">Select Nature of Business</option>
                                            {Object.entries(natureOfBusinessMap).map(([key, label]) => (
                                                <option key={key} value={key}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <span className="flex-1">
                                            {natureOfBusinessMap[leadJourney.nature_of_business] || leadJourney.nature_of_business}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Industry</b></span>
                                    {isEditing ? (
                                        <select
                                            name="industry"
                                            value={formData.industry || ""}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        >
                                            <option value="">Select Industry</option>
                                            {Object.entries(industryMap).map(([key, label]) => (
                                                <option key={key} value={key}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <span className="flex-1">
                                            {industryMap[leadJourney.industry] || leadJourney.industry}
                                        </span>
                                    )}
                                </div>
                            </div>
                            {/* Relationship Strength */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Relationship Strength</b></span>
                                    {isEditing ? (
                                        <select
                                            name="interest_level"
                                            value={relationshipStrengthNumericMap[formData.interest_level] || ""}
                                            onChange={handleRelationshipStrengthChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        >
                                            <option value="">Select Relationship Strength</option>
                                            {Object.entries(relationshipStrengthSelectMap).map(([value, label]) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <span className="flex-1 inline-flex items-center">
                                            {icon} <span className="ml-1">{label}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            {/* Street */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Street</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="street"
                                            value={formData.street || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.street}</span>
                                    )}
                                    <button
                                        onClick={() => handleCopyToClipboard(leadJourney?.street)}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </div>
                            </div>

                            {/* City */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>City</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.city}</span>
                                    )}
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(leadJourney.city);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </div>
                            </div>

                            {/* Post Code */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>Post Code</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="postal_code"
                                            value={formData.postal_code || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.postal_code}</span>
                                    )}
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(leadJourney.postal_code);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </div>
                            </div>

                            {/* State */}
                            <div className="flex items-start mt-5">
                                <div className='border-b border-gray-200 pb-2 w-full flex'>
                                    <span className="w-1/3"><b>State</b></span>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state || ''}
                                            onChange={handleChange}
                                            className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                        />
                                    ) : (
                                        <span className="flex-1">{leadJourney.state}</span>
                                    )}
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(leadJourney.state);
                                            toast.success('Copied to clipboard!');
                                        }}
                                        className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <img src="/icons/content_copy.svg" className='size-6'/>
                                    </button>
                                </div>
                            </div>

                                {["Referral (Hunter)", "Self Referral (Farmer)", "Referral (Farmer)", "Referral Scheme", "Referral (Public)"].includes(leadJourney.lead_source) && accDets && (
                                    <>
                                
                                <div className="flex items-center mt-5 mb-2">
                                    <p className="font-bold text-2xl -ml-5 w-full text-[#1E293B]">Referral</p>
                                </div>
                                <br></br>
                                {/* Name */}
                                <div className="col-span-2 flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/6"><b>Name</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="referrer_name"
                                                value={accDets.referrer_name || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets?.referrer_name}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.referrer_name);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                {/* Contact */}
                                <div className="col-span-2 flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/6"><b>Contact</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="referrer_contact"
                                                value={accDets.referrer_contact || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets.referrer_contact}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.referrer_contact);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                {/* Company */}
                                <div className="col-span-2 flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/6"><b>Company</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="referrer_company"
                                                value={accDets.referrer_company || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets.referrer_company}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.referrer_company);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                {/* Email */}
                                <div className="col-span-2 flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/6"><b>Email</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="referrer_email"
                                                value={accDets.referrer_email || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets.referrer_email}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.referrer_email);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                {/* Bank Name & Account Number */}
                                <div className="flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/3"><b>Bank Name</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="bank_name"
                                                value={accDets.bank_name || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets.bank_name}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.bank_name);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                <div className="flex items-start mt-5">
                                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                                        <span className="w-1/3"><b>Bank Account Number</b></span>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="bank_acc_no"
                                                value={accDets.bank_acc_no || ''}
                                                onChange={handleChange}
                                                className="flex-1 bg-gray-50 px-2 py-1 rounded border border-gray-200 text-left"
                                            />
                                        ) : (
                                            <span className="flex-1">{accDets.bank_acc_no}</span>
                                        )}
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(accDets.bank_acc_no);
                                                toast.success('Copied to clipboard!');
                                            }}
                                            className="ml-2 bg-white text-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                <img src="/icons/content_copy.svg" className='size-6'/>
                                        </button>
                                    </div>
                                </div>
                                </>
                                )}
                        </div>
                    </div>
                    
                )}

                {activeTab === 1 && (
                    <RelatedTab farmerID={accDets.farmer_id} leadID={leadID} accountOwner={accountOwner}/>
                )}


                {activeTab === 2 && (
                    <StatisticsTab leadID = {leadID} companyName = {leadJourney.company_name}/>
                )}

                {activeTab === 3 && (
                    accountOwner ? (    
                        <DocumentsTab lead_id={leadID}/>
                    ) : (
                        <ContactsTab leadID = {leadID} accountOwner={accountOwner}/>
                    )
                )}
                {activeTab === 4 && (
                    <ContactsTab leadID = {leadID} accountOwner={accountOwner}/>
                )}
            </div>

            {showReassignModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-lg w-1/3">
                        <span className="flex-1 -ml-1 inline-flex items-center">
                        <img src="/icons/edit.svg" className='size-6 mr-2'/>
                        <h2 className="text-xl font-bold mb-1">Reassign account to someone else?</h2>
                        </span>
                        <p className='border-b border-gray-200 w-full flex mb-4'></p>

                        <p>Current account owner</p>
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded mb-4 mt-1 bg-gray-100"
                            value={accDets.farmer_name}
                            readOnly
                        />

                        <p>Reassign to</p>
                        <select
                            className="w-full p-2 border border-gray-300 rounded mb-4 mt-1"
                            value={selectedFarmer}
                            onChange={(e) => setSelectedFarmer(e.target.value)}
                        >
                            <option value="">Select from list</option>
                            {farmerList.map((farmer) => (
                                <option key={farmer.id} value={farmer.username}>
                                    {farmer.username}
                                </option>
                            ))}
                        </select>
                        <div className="flex justify-end space-x-2">
                            <button
                                className="bg-white text-black py-3 px-4 rounded-3xl border-[1px] border-black hover:bg-gray-100"
                                onClick={() => setShowReassignModal(false)}
                            >
                                <b>Cancel</b>
                            </button>
                            <button
                                className="bg-yellow-300 text-black py-3 px-8 rounded-3xl hover:bg-yellow-400"
                                onClick={handleReassignSubmit}
                            >
                                <b>Continue</b>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showConfirmationModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                    
                    <div className="bg-white p-6 rounded-lg w-1/4">
                        {/* Center the icon using Flexbox */}
                        <div className="flex justify-center mb-2 pt-6">
                            <img src="/icons/edit.svg" className='size-11' />
                        </div>
        
                        <h1 className="text-2xl font-bold mb-3">Save & Update Owner</h1>
                        <p>Previous owner ({accDets.farmer_name}) will be updated. Please ensure selected new owner ({selectedFarmer}) are correct.</p>
                        <div className="mt-6 mb-6">
                            <button
                                className="text-black underline hover:text-blue-800 focus:outline-none"
                                onClick={handleConfirmationCancel}
                            >
                                <b>No, Don't Update</b>
                            </button>
                            
                        </div>
                        <button
                                className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                                onClick={handleConfirmationSubmit}
                            >
                                <b>Save & Update</b>
                            </button>
                    </div>
                </div>
            )}
            {showReassignConfirmationModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                    
                    <div className="bg-white p-6 rounded-lg w-1/4">
                        {/* Center the icon using Flexbox */}
                        <div className="flex justify-center mb-2 pt-6">
                            <img src="/icons/edit.svg" className='size-11' />
                        </div>
        
                        <h1 className="text-2xl font-bold mb-3">Save & Update Details</h1>
                        <p>Lead details will be updated. Please ensure new details are correct.</p>
                        <div className="mt-6 mb-6">
                            <button
                                className="text-black underline hover:text-blue-800 focus:outline-none"
                                onClick={handleConfirmationCancel}
                            >
                                <b>No, Don't Update</b>
                            </button>
                            
                        </div>
                        <button
                                className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                                onClick={handleReassignConfirmation}
                            >
                                <b>Save & Update</b>
                            </button>
                    </div>
                </div>
            )}
        </div>
    );
}